var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M471 261.4L260.9 49.8l-1.5-1.5h-.4c-8.3-7.9-17.9-12-29.9-12.3l-99.7-3.7-4.4-.2c-11.2.2-22.2 4.5-30.7 13.1L45.1 94.3c-9 9-13.1 20.9-13.1 32.7v.1l.3 4.2 6.7 97.3v2.1c1 8.7 4.5 17.3 10.4 24.4l5.5 5.4 206.3 208.8 3.1 3.1c11.9 10.5 30 10 41.3-1.4L471 304.4c11.8-11.8 12-31.1 0-43zM144 192c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.8941afcc0ead870d0fa3ce19bae84742.svg";
export { ForwardRef as ReactComponent };